// components
import { Box } from '@mui/material';

// libs
import { FC, useMemo } from 'react';
import { HeaderProps } from 'react-big-calendar';
import { capitalize } from 'lodash';

// stores
import { useCalendarStore } from 'components/mrp/stores/calendarStore/calendarStore';

const CalendarColumnHeader: FC<HeaderProps> = ({ label }: HeaderProps) => {
  const calendars = useCalendarStore((state) => state.calendars);

  const { weekday, dateString } = useMemo(() => {
    const labelParts = label.split(' ');

    const weekday =
      Object.keys(calendars).length < 3
        ? labelParts[0]
        : labelParts[0].slice(0, 2);

    return {
      weekday,
      dateString: labelParts.splice(1).join(' ')
    };
  }, [calendars, label]);

  return (
    <>
      <Box>{capitalize(weekday)}</Box>
      <Box>{dateString}</Box>
    </>
  );
};

export default CalendarColumnHeader;
